if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super()

        const button = this.querySelector('button')
        if (button) {
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target)
          })
        }
      }

      connectedCallback() {
        this.fetchAvailability(this.dataset.productHandle, this.dataset.productId, this.dataset.variantId)
      }

      formatUSPhoneNumber(phone) {
        const cleaned = ('' + phone.replace('+1', '')).replace(/\D/g, '')
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
        if (match) {
          return `${match[1]}-${match[2]}-${match[3]}`
        }
        return null
      }

      async fetchLocations() {
        const shopName = 'hudson-grace-usd-new'
        const apiVersion = '2025-10'
        const accessToken = '9922a14e2159c4f3ffcd79de1b214bf0'

        const query = `
          query {
            locations(first: 20) {
              edges {
                node {
                  id
                  name
                  openingHour: metafield(namespace: "location", key: "opening_hours") {
                    value
                  }
                }
              }
            }
          }
        `

        const url = `https://${shopName}.myshopify.com/api/${apiVersion}/graphql.json`

        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': accessToken,
            },
            body: JSON.stringify({ query }),
          })

          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

          const responseData = await response.json()
          return responseData.data?.locations?.edges || []
        } catch (error) {
          console.error('Error fetching locations:', error.message)
          return []
        }
      }

      async fetchAvailability(productHandle, productId, variantId) {
        const storeUrl = `https://api.locationinventory.info/inventory?shop=hudson-grace-usd-new.myshopify.com&handle=${productHandle}&id=${productId}`

        const locationData = await this.fetchLocations()

        fetch(storeUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => response.json())
          .then((data) => {
            this.renderAvailability(data.variantLocations, variantId, locationData)
          })
          .catch((e) => {
            console.error('Error fetching store availability:', e.message)
          })
      }

      renderAvailability(variantLocations, variantId, locationData) {
        const drawer = this.querySelector('pickup-availability-drawer')
        if (!variantLocations || variantLocations.length === 0) {
          const paragraph = document.createElement('p')
          paragraph.textContent = 'No store availability found.'
          drawer.appendChild(paragraph)
          return
        }

        const variantLocation = variantLocations.find((node) => parseInt(node.variant) === parseInt(variantId))

        const itemList = drawer.querySelector('.pickup-availability-list')
        itemList.innerHTML = ''
        // Render each store availability node
        variantLocation?.inventoryLocations
          .filter(
  (node) =>
    node.quantity > 0 &&
    !node.location.name.toLowerCase().includes('corp office') &&
    !node.location.name.toLowerCase().includes('distribution center')
)

          .forEach((node) => {
            const location = node.location
            if (!location) return

            const openingHour =
              locationData.find((loc) => loc.node.name === location.name)?.node.openingHour?.value || ''

            const htmlString = `
            <li class='pickup-availability-list__item'>
              <div class="pickup-availability-location">
                <h5 class='paragraph-small'>
                  ${location.city}, ${location.province}
                </h5>
              </div>
              <p class='paragraph-extra-small'>${location.name} | ${location.address1}</p>

              <div class='caption pickup-availability-status ${
                node.quantity === 0 ? 'oos' : node.quantity === 1 ? 'low' : ''
              }'>              
                <span>
                  ${node.quantity > 0 ? node.quantity : ''}${' '}
                  ${
                    node.quantity > 1
                      ? 'Available'
                      : node.quantity === 1
                      ? 'Limited quantity available'
                      : 'Out of stock'
                  }
                </span>
                
              </div>

              ${
                location.phone
                  ? `<address class='pickup-availability-address'>
                      <a href="tel:${location.phone}">
                        <svg class='icon' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                        </svg>

                        Contact the store
                      </a>
                    </address>`
                  : ''
              }

              ${
                openingHour
                  ? `<details>
                      <summary class="paragraph-extra-small">
                        <svg class='icon' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>

                        Opening Hours
                      </summary>
                      <span class="pickup-availability-hours paragraph-extra-small">${openingHour}</span>
                    </details>`
                  : ''
              }
              
            </li>
          `
            itemList.insertAdjacentHTML('beforeend', htmlString)
          })
      }
    }
  )
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super()

        this.onBodyClick = this.handleBodyClick.bind(this)

        this.querySelector('button').addEventListener('click', () => {
          this.hide()
        })

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide()
        })
      }

      handleBodyClick(evt) {
        const target = evt.target
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide()
        }
      }

      hide() {
        this.removeAttribute('open')
        document.body.removeEventListener('click', this.onBodyClick)
        document.body.classList.remove('overflow-hidden')
        removeTrapFocus(this.focusElement)
      }

      show(focusElement) {
        this.focusElement = focusElement
        this.setAttribute('open', '')
        document.body.addEventListener('click', this.onBodyClick)
        document.body.classList.add('overflow-hidden')
        trapFocus(this)
      }
    }
  )
}
